import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import {
  approved as approvedMessage,
  approve
} from '../../../../utils/messages'
import {
  isInternalReviewer,
  isQuestCopyEditorOrQuestAuthor,
  isQuestManager
} from '../../../../utils/user'
import { questIsAssignedToUser } from '../../../../utils/assignment'
import { isNullOrEmpty } from '../../../../utils'

export default class ReviewCheckbox extends Component {
  getClassList() {
    const { quest, user, organization } = this.props
    let classList = ['review-checkbox']
    if (isInternalReviewer(user) || isQuestManager(user)) {
      classList.push('reviewer')
    }
    if (isQuestCopyEditorOrQuestAuthor(user, quest, organization)) {
      classList.push('author')
    }
    if (!isNullOrEmpty(quest.reviewing_compiled_quest)) {
      classList.push('not-draft')
    }
    return classList.join(' ')
  }

  render() {
    const { user, quest, organization, approved } = this.props
    const klass = this.getClassList()
    const approvedClass = approved ? 'approved' : ''

    return (
      <div className={`${klass} ${approvedClass}`}>
        <div className={'checkbox'} onClick={this.props.setApproved} />
        <div
          className={`check ${approvedClass}`}
          onClick={this.props.setApproved}
        />
        {approved && <h2>{approvedMessage}</h2>}
        {!approved &&
          (() => {
            if (isInternalReviewer(user) || isQuestManager(user)) {
              return <h2>{approve}</h2>
            } else if (
              isQuestCopyEditorOrQuestAuthor(user, quest, organization) &&
              (questIsAssignedToUser(quest, user) ||
                isNullOrEmpty(quest.assigned_to))
            ) {
              return (
                <div
                  className="button btn-secondary-small"
                  onClick={this.props.handleAssignClick}
                >
                  <FormattedMessage
                    id={'ReviewCheckox.AssignToAReviewer'}
                    defaultMessage={'Assign to a Reviewer'}
                  />
                </div>
              )
            } else {
              return (
                <h2 className="not-yet-approved">
                  <FormattedMessage
                    id={'ReviewCheckbox.NotYetApproved'}
                    defaultMessage={'Not yet Approved'}
                  />
                </h2>
              )
            }
          })()}
      </div>
    )
  }
}

ReviewCheckbox.propTypes = {
  setApproved: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  approved: PropTypes.bool.isRequired,
  type: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/ReviewCheckbox.js